/** Angular Imports */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

/** Routing Imports */
import { Route } from '../core/route/route.service';
import { PermissionGuard } from '../core/authentication/permission.guard';

/** Translation Imports */
import { extract } from '../core/i18n/i18n.service';

/** Custom Components */
import { UsersComponent } from './users.component';
import { CreateUserComponent } from './create-user/create-user.component';
import { ViewUserComponent } from './view-user/view-user.component';

/** Custom Resolvers */
import { UsersResolver } from './users.resolver';
import { UsersTemplateResolver } from './users-template.resolver';
import { UserResolver } from './user.resolver';

/** Users Routes */
const routes: Routes = [
  Route.withShell([
    {
      path: 'users',
      canActivate: [PermissionGuard],
      data: { title: extract('Users'), breadcrumb: 'Users', permissions: ['ALL_FUNCTIONS', 'READ_USER'] },
      children: [
        {
          path: '',
          component: UsersComponent,
          resolve: {
            users: UsersResolver,
            usersTemplate: UsersTemplateResolver
          }
        },
        {
          path: 'create',
          canActivate: [PermissionGuard],
          component: CreateUserComponent,
          data: { title: extract('Create User'), breadcrumb: 'Create User', permissions: ['ALL_FUNCTIONS', 'CREATE_USER'] },
          resolve: {
            usersTemplate: UsersTemplateResolver
          }
        },
        {
          path: ':id',
          canActivate: [PermissionGuard],
          data: { title: extract('View User'), routeResolveBreadcrumb: ['user', 'username'], permissions: ['ALL_FUNCTIONS', 'READ_USER'] },
          resolve: {
            user: UserResolver
          },
          children: [
            {
              path: '',
              component: ViewUserComponent
            }
          ]
        }
      ]
    }
  ])
];

/**
 * Users Routing Module
 *
 * Configures the users routes.
 */
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
    UsersResolver,
    UsersTemplateResolver,
    UserResolver
  ]
})
export class UsersRoutingModule { }
